import { getUserInfo } from '../api/home'

const SESSION_USER_CACHE_TTL = 5000
let sessionUserRequestPromise = null
let cachedSessionUserResponse = null
let cachedSessionUserError = null
let cachedSessionUserAt = 0

export const hasShareSessionCookie = () => document.cookie
  .split(';')
  .map(item => item.trim())
  .some(item => item.startsWith('share-session=') && item.slice('share-session='.length).trim())

export const isAuthenticatedUser = response => Boolean(
  response &&
  response.code === 1 &&
  response.data &&
  response.data.name !== '游客'
)

export const clearAuthenticatedSessionCache = () => {
  cachedSessionUserResponse = null
  cachedSessionUserError = null
  cachedSessionUserAt = 0
}

// 路由守卫和首页共用同一次 getme 结果，避免刷新受保护页面时重复请求。
export const getAuthenticatedSessionInfo = async ({ force = false } = {}) => {
  if (!hasShareSessionCookie()) {
    clearAuthenticatedSessionCache()
    return null
  }

  const cacheIsFresh = Date.now() - cachedSessionUserAt < SESSION_USER_CACHE_TTL
  if (!force && cacheIsFresh && cachedSessionUserResponse) return cachedSessionUserResponse
  if (!force && cacheIsFresh && cachedSessionUserError) throw cachedSessionUserError
  if (sessionUserRequestPromise) return sessionUserRequestPromise

  const request = getUserInfo().then(response => {
    if (isAuthenticatedUser(response)) {
      cachedSessionUserResponse = response
      cachedSessionUserError = null
      cachedSessionUserAt = Date.now()
    } else {
      clearAuthenticatedSessionCache()
    }
    return response
  }).catch(error => {
    cachedSessionUserResponse = null
    cachedSessionUserError = error
    cachedSessionUserAt = Date.now()
    throw error
  })
  sessionUserRequestPromise = request

  try {
    return await request
  } finally {
    if (sessionUserRequestPromise === request) sessionUserRequestPromise = null
  }
}

// 只有服务端明确判定会话无效时才拦截；500、超时或网络异常不应把用户踢回登录页。
export const verifyAuthenticatedSession = async () => {
  // 当前业务约定：没有 share-session Cookie 就是游客，无需再等待接口超时。
  if (!hasShareSessionCookie()) return false

  try {
    return isAuthenticatedUser(await getAuthenticatedSessionInfo())
  } catch (error) {
    const status = error && error.response && error.response.status
    return ![401, 419].includes(status)
  }
}
